"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hhCostReportFinancials = {
    name: 'hh-cost-report-financials',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const hhCostReportFte = {
    name: 'hh-cost-report-fte',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const hhCostReportPatients = {
    name: 'hh-cost-report-patients',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const hhCostReportVisits = {
    name: 'hh-cost-report-visits',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
exports.default = [
    hhCostReportFinancials,
    hhCostReportFte,
    hhCostReportPatients,
    hhCostReportVisits,
];
